// extracted by mini-css-extract-plugin
export default {"modal":"VT-z","sharingIconsV2":"WT-z","notificationBox":"XT-z","checkMark":"YT-z","textFrame":"ZT-z"};